import axios from 'axios'
const { VUE_APP_TEST_ERROR, VUE_APP_VT_API_URL } = process.env

const loadSQLData = async (payload) => {
  const result = { error: false }
  try {
    const url =
      VUE_APP_TEST_ERROR || `${VUE_APP_VT_API_URL}/vt-api/viewtrail/mysqlessentialinformation`
    const res = await axios
      .post(url, payload)
    if (res && res.data) {
      result.data = res.data
    }
    return result
  } catch (err) {
    result.error = true
    return result
  }
}

const getDrivingInstructions = async (url) => {
  try {
    const res = await axios.get(url);
    return res.data
  } catch(err){
    result.error = true
    return err
  }
}

export {
  loadSQLData,
  getDrivingInstructions
}
